// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var ListUtils$SmartcutsMacros = require("../../bs-utils/src/ListUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");

function t_encode(encoder_domHtmlElement, v) {
  return Js_dict.fromArray([
              [
                "target",
                Curry._1(encoder_domHtmlElement, v.target)
              ],
              [
                "relatedTarget",
                Decco.optionToJson(encoder_domHtmlElement, v.relatedTarget)
              ],
              [
                "timeStamp",
                Decco.floatToJson(v.timeStamp)
              ]
            ]);
}

function t_decode(decoder_domHtmlElement, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var target = Curry._1(decoder_domHtmlElement, Belt_Option.getWithDefault(Js_dict.get(dict$1, "target"), null));
  if (target.TAG === /* Ok */0) {
    var relatedTarget = Decco.optionFromJson(decoder_domHtmlElement, Belt_Option.getWithDefault(Js_dict.get(dict$1, "relatedTarget"), null));
    if (relatedTarget.TAG === /* Ok */0) {
      var timeStamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timeStamp"), null));
      if (timeStamp.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  target: target._0,
                  relatedTarget: relatedTarget._0,
                  timeStamp: timeStamp._0
                }
              };
      }
      var e = timeStamp._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".timeStamp" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = relatedTarget._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".relatedTarget" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = target._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".target" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function map(mapDomHtmlElement, item) {
  return {
          target: Curry._1(mapDomHtmlElement, item.target),
          relatedTarget: OptionUtils$SmartcutsMacros.map(item.relatedTarget, mapDomHtmlElement),
          timeStamp: item.timeStamp
        };
}

var Item = {
  t_encode: t_encode,
  t_decode: t_decode,
  map: map
};

function init(param) {
  return /* [] */0;
}

function update(focusEvent, trail) {
  return {
          hd: {
            target: focusEvent.target,
            relatedTarget: OptionUtils$SmartcutsMacros.map(Caml_option.nullable_to_opt(focusEvent.relatedTarget), (function (target) {
                    return target;
                  })),
            timeStamp: focusEvent.timeStamp
          },
          tl: trail
        };
}

function getFocusedElementJustBeforeClickEvent(withinMilliseconds, clickEvent, trail) {
  var mouseTimeStamp = clickEvent.timeStamp;
  var maybeIndex = ListUtils$SmartcutsMacros.findIndex((function (param) {
          return mouseTimeStamp - param.timeStamp > withinMilliseconds;
        }), trail);
  if (maybeIndex === undefined) {
    return ;
  }
  var desiredIndex = maybeIndex - 1 | 0;
  return OptionUtils$SmartcutsMacros.andThen((function (param) {
                return param.relatedTarget;
              }), Belt_List.get(trail, desiredIndex));
}

exports.Item = Item;
exports.init = init;
exports.update = update;
exports.getFocusedElementJustBeforeClickEvent = getFocusedElementJustBeforeClickEvent;
/* No side effect */
